<template>
	<div class="status" :class="'status-'+color">
		<div class="dots">
			<span v-for="(dot,index) in dots" :ref="'dot-'+index" :key="index" class="dot" :class="{['hint-'+index]: true, letter: typeof dot === 'string', syn: typeof dot === 'boolean'}"></span>
			<div class="bar-2" ><div class="inside-bar" :style="{width: bar2.width+'%'}"></div></div>
		</div>
		<div class="pre-count">
			<div class="score">
				<span>Punti</span> {{score}}
			</div>
		<div class="bar-1" ><div class="inside-bar" :style="{width: bar1.width+'%'}"></div></div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['wordData','timeout','preCount','color'],
	data() {
		return {
			dots: [],
			used: [],
			startingScore: this.$store.state.difficult == 0? 100 : 200,
			score: 0,
			bar2: {
				width: 100,
				time: 0,
				active: 0
			},
			bar1: {
				width: 100,
				time: 0,
				active: -1
			},
			timer: false
		}
	},
	watch: {
		'$store.state.endRound'(endRound) {
			if(endRound == 'win' || endRound == 'lost') {
				clearInterval(this.timer)
			}
			else {
				this.startGame();
			}
		}
	},
	methods: {
		random(max) {
			let random = Math.floor(Math.random() * max);
			if(this.used.includes(random)) {
				return this.random(max);
			}
			else {
				this.used.push(random);
				return random;
			}
		},
		shuffle(word) {
			//Shuffle the remaining letters
			let result = {
				letters: [],
				word: false
			};
			for(let letter in word) {
				let random = this.random(word.length);
				result.letters[letter] = random;
			}
			result.word = word;

			return result;
		},
		startGame() {
			// Aggiungo la prima lettera nello stack
			this.used = [];
			this.dots = [];
			this.score = this.startingScore;
			clearInterval(this.timer);
			this.bar2 = {
				width: 100,
				time: 0,
				active: 0
			};
			this.bar1 = {
				width: 100,
				time: 0,
				active: -1
			};

			this.dots.push(this.wordData.word[0]); 

			let word = this.wordData.word.split('');
			word.shift();
			let shuffle = this.shuffle(word);
			
			let isInserted = false;

			for(let letter in shuffle.letters) {
				// Controllo se esiste il sinonimo, è già stato inserito ed eventualmente lo pusho a caso in un random
				if(this.wordData.syn && this.wordData.syn.length > 1 && !isInserted && Math.random() < 0.5) {
					isInserted = true;
					this.dots.push(true);
				}
				this.dots.push(word[shuffle.letters[letter]]);
			}

			if(this.wordData.syn && this.wordData.syn.length > 1 && !isInserted) {
				this.dots.push(true); 
			}

			let tick = 25;
			let tickPreCount = this.preCount*1000;
			let tickTimeout = this.timeout*1000;
			
			let prevActive = -1;
			let scroll = 0;
			let percForHint = 100/(this.dots.length - 1);
			
			let singlePoint = Math.ceil(this.startingScore / this.dots.length - 1);
			let firstLetter = false;
			this.timer = setInterval(() => {
				if(tickPreCount <= 0 && tickTimeout <= 0) {
					clearInterval(this.timer);
				}

				if(tickPreCount > 0) {
					/* tickPreCount, Pronti...? */
					tickPreCount -= tick;
					this.bar1.width = (tickPreCount*100)/(this.preCount*1000);
				}
				else {
					
					/* tickPreCount iniziale finito, iniziano i suggerimenti */
					tickTimeout -= tick;
					this.bar2.width = (tickTimeout*100)/(this.timeout*1000);

					prevActive = this.bar2.active;
					this.bar2.active = this.dots.length - Math.floor(this.bar2.width /percForHint) - 2;

					/* Suddivido il tempo per lanciare i suggerimenti in maniera democratica nel tempo */
					if(this.bar2.active !== prevActive || !firstLetter) {
						
						switch(true) {
	
							case this.bar2.active === 0:
								firstLetter = true;
								this.$refs['dot-0'][0]['classList'] += ' on';

								this.$emit('letter',{
									letter: this.wordData.word[0],
									offset: 0
								});
							break;
	
							case typeof this.dots[this.bar2.active] === 'boolean':
								this.$refs['dot-'+this.bar2.active][0]['classList'] += ' on';
								this.$emit('synonym',true);
							break;
	
							default:
								this.$refs['dot-'+this.bar2.active][0]['classList'] += ' on';
								this.$emit('letter',{
									letter: word[shuffle.letters[scroll]],
									offset: shuffle.letters[scroll]+1
								});
								scroll++;
						}
	
						this.score = this.score - singlePoint;
						this.score = this.score < singlePoint? 0 : this.score;
					}
				}
				this.$emit('score',this.score);
				
			},tick);
		}
	},
	mounted() {
		this.startGame();
	}
}
</script>
<style scoped lang="scss">

	.status {
		$space: 15;
		background: #fff;
		border-radius: px(50);
		overflow: hidden;
		position: absolute;
		width: 100%;
		padding: px(6) px(20);
		display: flex;

		.pre-count {
			padding-left: 1rem;
		}

		&.status-orange {
			.pre-count .score {
				color: $mondadori-orange;
			}

			.dots .bar-2 .inside-bar {
				background: $mondadori-orange;
			}

			.dots .dot:after {
				border-color: $mondadori-orange;
			}

			.dot.letter {
				background: $mondadori-orange;
			}

			.dot.syn {
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'%3E%3Cpath id='Poligono_1' data-name='Poligono 1' d='M10.751,3.157a2,2,0,0,1,3.5,0l2.067,3.73a2,2,0,0,0,1.3.981l4.164.949a2,2,0,0,1,1.08,3.245l-2.942,3.463a2,2,0,0,0-.467,1.486l.434,4.517a2,2,0,0,1-2.831,2.006l-3.72-1.723a2,2,0,0,0-1.681,0L7.94,23.534a2,2,0,0,1-2.831-2.006l.434-4.517a2,2,0,0,0-.467-1.486L2.134,12.062a2,2,0,0,1,1.08-3.245l4.164-.949a2,2,0,0,0,1.3-.981Z' fill='%237ccfa9'/%3E%3C/svg%3E%0A");
			}
		}

		&.status-pink {
			.pre-count .score {
				color: $mondadori-pink;
			}

			.dots .bar-2 .inside-bar {
				background: $mondadori-pink;
			}

			.dots .dot:after {
				border-color: $mondadori-pink;
			}

			.dot.letter {
				background: $mondadori-pink;
			}
			.dot.syn {
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'%3E%3Cpath id='Poligono_1' data-name='Poligono 1' d='M10.751,3.157a2,2,0,0,1,3.5,0l2.067,3.73a2,2,0,0,0,1.3.981l4.164.949a2,2,0,0,1,1.08,3.245l-2.942,3.463a2,2,0,0,0-.467,1.486l.434,4.517a2,2,0,0,1-2.831,2.006l-3.72-1.723a2,2,0,0,0-1.681,0L7.94,23.534a2,2,0,0,1-2.831-2.006l.434-4.517a2,2,0,0,0-.467-1.486L2.134,12.062a2,2,0,0,1,1.08-3.245l4.164-.949a2,2,0,0,0,1.3-.981Z' fill='%23f251a5'/%3E%3C/svg%3E%0A");
			}
		}

		.pre-count {
			display: flex;
			position: relative;
			flex-basis: 20%;
			.score {
				top: 40%;
				height: 2rem;
				line-height: 2rem;
				position: relative;
				transform: translateY(-50%);
				@include breakpoint(s) {
					span {
						font-size: px(12);
						text-transform: uppercase;
					}
				}
			}
			.bar-1 {
				position: absolute;
				width: 100%;
				display: inline-block;
				height: px(2);
				background: #D3E3FD;
				bottom: px(12);
				z-index: 0;
				left: -0.5rem;

				.inside-bar {
					position: absolute;
					display: inline-block;
					left: 0;
					right: 0;
					width: 100%;
					background: $mondadori-blue;
					transition-timing-function: linear;
					height: px(2);
				}
			}
		}

		.dots {
			flex-basis: 100%;
			display: flex;
			flex-direction: row-reverse;
			position: relative;
			justify-content: space-between;

			.bar-2 {
				position: absolute;
				width: calc(100% - 1rem);
				display: inline-block;
				height: px(2);
				background: #D3E3FD;
				bottom: px(12);
				z-index: 0;
				left: 0.5rem;
				
				.inside-bar {
					position: absolute;
					display: inline-block;
					left: 0;
					right: 0;
					width: 100%;
					transition-timing-function: linear;
					height: px(2);
				}
			}

			.dot {
				margin-bottom: px(20);
				margin-top: px(10);
				display: inline-block;
				width: px(20);
				height: px(20);
				transition: all 0.3s;
				background-size: contain;
				position: relative;
				z-index: 1;

				&:after {
					content: '';
					position: absolute;
					bottom: px(-$space);
					left: 50%;
					transform: translateX(-50%);
					display: inline-block;
					width: px(10);
					height: px(10);
					background: #fff;
					border-radius: 100%;
					border: px(2) solid;
				}

				&.letter {
					border: px(3) solid #fff;
					border-radius: px(5);
					&.on {
						background: #BED6FD;
					}
				}
				
				&.syn {
					&:after {
						bottom: px(-$space+3);
					}
					&:before {
						content: '';
						position: absolute;
						width: 100%;
						height: 100%;
						opacity: 0;
						background-size: contain;
						transition: 0.3s all;
					}
					&.on {
						&:before {
							opacity: 1;
							background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'%3E%3Cpath id='Poligono_1' data-name='Poligono 1' d='M10.751,3.157a2,2,0,0,1,3.5,0l2.067,3.73a2,2,0,0,0,1.3.981l4.164.949a2,2,0,0,1,1.08,3.245l-2.942,3.463a2,2,0,0,0-.467,1.486l.434,4.517a2,2,0,0,1-2.831,2.006l-3.72-1.723a2,2,0,0,0-1.681,0L7.94,23.534a2,2,0,0,1-2.831-2.006l.434-4.517a2,2,0,0,0-.467-1.486L2.134,12.062a2,2,0,0,1,1.08-3.245l4.164-.949a2,2,0,0,0,1.3-.981Z' fill='%23BED6FD'/%3E%3C/svg%3E%0A");					
						}
					}
				}

				&.on {
					&:after {
						background: #BED6FD;
						border-color: transparent;
					}
				}
			}
		}
	}
</style>